import React, { useState } from "react";
import { Row, FormInstance, Radio, RadioChangeEvent, Form } from "antd";
import styles from "./PersonForm.module.scss";

type Props = {
  labels: Record<string, string>;
  form: FormInstance;
  accommodationType: "wandaAccommodations";
};

const PersonAccommodations: React.FC<Props> = ({
  form,
  labels,
  accommodationType,
}) => {
  const [forceRender, setForceRender] = useState<boolean>(false);

  const handleAccommodationsChange = (
    e: RadioChangeEvent,
    fieldType: "wheelChairTravel" | "wheelChairPresent" | "wcToVehicleTransfer"
  ) => {
    const { value } = e.target;

    form.setFieldsValue({
      [accommodationType]: {
        [fieldType]: value,
      },
    });

    if (fieldType === "wheelChairTravel") {
      form.setFieldsValue({
        [accommodationType]: {
          wheelChairPresent: value,
          wcToVehicleTransfer: value,
        },
      });
    }

    setForceRender(!forceRender);
  };

  const renderRadioGroup = (
    fieldType: "wheelChairTravel" | "wheelChairPresent" | "wcToVehicleTransfer"
  ) => {
    return (
      <Radio.Group
        onChange={(e) => handleAccommodationsChange(e, fieldType)}
        className={styles.radio}
      >
        {["Yes", "No"].map((option, index) => {
          const value = index === 0;
          const isSelected =
            value === form.getFieldValue(accommodationType)[fieldType];

          return (
            <Radio
              key={option}
              value={value}
              className={`${styles.radioOption} ${isSelected &&
                styles.radioSelected}`}
            >
              {option}
            </Radio>
          );
        })}
      </Radio.Group>
    );
  };

  return (
    <>
      <Form.Item
        name={[accommodationType, "wheelChairTravel"]}
        label={<Row className={styles.accommLabel}>{labels.wheelChair}</Row>}
      >
        {renderRadioGroup("wheelChairTravel")}
      </Form.Item>

      <Form.Item
        shouldUpdate={(prevValues, currentValues) =>
          prevValues.wheelChairTravel !== currentValues.wheelChairTravel
        }
      >
        {({ getFieldValue }) => {
          return (
            getFieldValue(accommodationType).wheelChairTravel && (
              <>
                <Form.Item
                  name={[accommodationType, "wheelChairPresent"]}
                  label={
                    <Row className={styles.accommLabel}>
                      {labels.standardFoldableWheelchair}
                    </Row>
                  }
                >
                  {renderRadioGroup("wheelChairPresent")}
                </Form.Item>

                <Form.Item
                  name={[accommodationType, "wcToVehicleTransfer"]}
                  label={
                    <Row className={styles.accommLabel}>
                      {labels.transferableWheelchair}
                    </Row>
                  }
                >
                  {renderRadioGroup("wcToVehicleTransfer")}
                </Form.Item>
              </>
            )
          );
        }}
      </Form.Item>
    </>
  );
};

export default PersonAccommodations;
